import React from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { setDate } from "../../redux/feature/billingSlice";
import { b } from "../../styles/variables";
import { getDateBasedOrdersApi } from "../../api/allAxios";

function FinanceByDate() {

  const { dateRange } = useSelector((state) => state.billing);

  const dispatch = useDispatch();

  const handleStartDateChange = (date) => {
    dispatch(setDate({
      startDate: date.toLocaleDateString('en-GB').split('/').reverse().join('-'),
      endDate: dateRange.endDate
    }));
  };

  const handleEndDateChange = (date) => {
    dispatch(setDate({
      startDate: dateRange.startDate,
      endDate: date.toLocaleDateString('en-GB').split('/').reverse().join('-')
    }));
  };

  const handleFetchData = async () => {
    if (dateRange.startDate && dateRange.endDate) {
      const formattedStartDate = dateRange.startDate.replace(/-/g, '');
      const formattedEndDate = dateRange.endDate.replace(/-/g, '');
      
      try {
        const res = await getDateBasedOrdersApi(formattedStartDate, formattedEndDate);

				const resData = res?.data?.order_by_date;
        if (!resData || resData.length === 0) {
          console.error('No data received from API');
          return;
        }



        const headers = Object.keys(resData[0] || {}).join(',');
        const rows = resData?.map(item => Object.values(item).join(','));
        const csvContent = [headers, ...rows].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        
        const url = window.URL.createObjectURL(blob);
        
        const a = document.createElement('a');
        a.href = url;
        a.download = `orders_${formattedStartDate}_to_${formattedEndDate}.csv`;
        
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } catch (error) {
        console.error('Error in handleFetchData:', error);
      }
    } else {
      console.error('Start date or end date is missing');
    }
  };



  return (
    <MainContainer>
      <Main>
        <HeaderContainer>Reports</HeaderContainer>
        <BodyContainer>
          <DateLineContainer>
            <DateContainer>
              <p>Start Date: </p>
              <CustomDatePicker
                selected={new Date(dateRange.startDate)}
                onChange={handleStartDateChange}
                minDate={new Date("2023-05-09")}
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy"
              />
            </DateContainer>
            <DateContainer>
              <p>End Date: </p>
              <CustomDatePicker
                selected={new Date(dateRange.endDate)}
                onChange={handleEndDateChange}
                minDate={new Date(dateRange.startDate)}
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy"
              />
            </DateContainer>
						<ButtonContainer>
					<FetchButton onClick={handleFetchData}>Download</FetchButton>

					</ButtonContainer>
          </DateLineContainer>

         
        </BodyContainer>
      </Main>
    </MainContainer>
  );
}

export default FinanceByDate;

const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-family: nunito sans-serif;
  color: #180270;
`;

const Main = styled.div`
  width: 70%;
  background: white;
  padding: 0 1%;
`;

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
	font-size: 2.5rem;
	font-weight: 700;
  flex-direction: row;
  justify-content: center;
  padding: 6px 0;
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;

`;
const DateContainer = styled.div`
			@media ${b.mobile} {
			padding-bottom: 2.5rem;
  }
	@media ${b.tablet} {
		padding-bottom: 2.5rem;
  }
`;
const DateLineContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 1rem 2rem 5rem;
    -webkit-box-pack: justify;
    justify-content: space-between;

		@media ${b.mobile} {
			grid-template-columns: repeat(1, 1fr);
  }
	@media ${b.tablet} {
			grid-template-columns: repeat(1, 1fr);
  }
`;

const CustomDatePicker = styled(DatePicker)`
  border: 1px solid gray;
  text-align: center;
  border-radius: 40px;
`;

export const FetchButton = styled.button`
  background: linear-gradient(90deg, #f7707d 0%, #f29173 100%);
  border-radius: 2.2rem;
  padding: 10px 20px;
  border: none;
  color: white;
	width: max-content;
  font-weight: 500;
  font-size: 1.3rem;
  &:hover {
    cursor: pointer;
  }
  @media ${b.mobile} {
    border-radius: 1.5rem;
    font-size: 80%;
  }
`;
